import { render, staticRenderFns } from "./rgpd.vue?vue&type=template&id=3d9b44b8&scoped=true&"
import script from "./rgpdControl.js?vue&type=script&lang=js&"
export * from "./rgpdControl.js?vue&type=script&lang=js&"
import style0 from "./rgpd.css?vue&type=style&index=0&id=3d9b44b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9b44b8",
  null
  
)

export default component.exports